import AppWaldenViewController from '../walden-view';

export default class AppServicesWaldenViewRefController extends AppWaldenViewController {
  detailRouteName = 'app.services.walden-view-ref.detail';
}
